import {
  isPodsApplied,
  podFilterDataExtractor,
  PodsAppliedFilterRenderer,
  PodsFilterBody,
} from 'app/features/teams/messages/table-filters/PodsFilter'
import {
  isSortFilterApplied,
  SortAppliedFilterRenderer,
  sortDataExtractor,
  SortFilterBody,
} from 'app/pages/teams/rental-references/components/SearchAndFilter/SortFilter'
import {
  isStatusFilterApplied,
  StatusAppliedFilterRenderer,
  statusDataExtractor,
  StatusFilterBody,
} from 'app/pages/teams/rental-references/components/SearchAndFilter/StatusFilter'
import {
  isPropertyManagerApplied,
  PropertyManagerAppliedFilterRenderer,
  PropertyManagerFilterBody,
  propertyManagerFilterDataExtractor,
} from 'app/sm/manager_viewings/ManagerViewingsFilters/PropertyManagerFilter'

export const filtersIds = {
  manager: 'manager',
  pods: 'pods',
  status: 'status',
  sort: 'sort',
}

export const filtersInitialState = {
  [filtersIds.manager]: {},
  [filtersIds.pods]: {},
  [filtersIds.status]: {},
  [filtersIds.sort]: {},
  search: '',
}

const filtersAppliedChecker = {
  [filtersIds.manager]: isPropertyManagerApplied,
  [filtersIds.pods]: isPodsApplied,
  [filtersIds.status]: isStatusFilterApplied,
  [filtersIds.sort]: isSortFilterApplied,
}

export const hasAppliedFilters = (filtersState: { [x: string]: any }) => {
  if (!filtersState) return false
  return Object.values(filtersIds).some((filterId) => {
    const filterValue = filtersState?.[filterId]
    const filterAppliedChecker = filtersAppliedChecker?.[filterId]
    return filterAppliedChecker?.(filterValue)
  })
}

export const getFilters = (filtersState: {
  [x: string]: any
  search?: string
}) => {
  const managers = propertyManagerFilterDataExtractor(
    filtersState[filtersIds.manager],
  ).managers
  const pods = podFilterDataExtractor(filtersState[filtersIds.pods]).pods
  const statuses = statusDataExtractor(filtersState[filtersIds.status]).statuses
  const sort = sortDataExtractor(filtersState[filtersIds.sort]).sort

  return {
    managers,
    pods,
    statuses,
    sort,
  }
}

const getRenderedFiltersConfig = (
  filterId: string,
  filtersValues: { [x: string]: any },
  updateFilterFn: any,
) => {
  const filterValues = filtersValues?.[filterId]
  return {
    filterValues,
    isApplied: filtersAppliedChecker?.[filterId]?.(filterValues),
    setFilterValues: (values: any) => updateFilterFn(filterId, values),
  }
}

export const buildRenderedFilterConfig = (
  filtersValues: any,
  updateFilterFn?: any,
) => {
  return {
    [filtersIds.manager]: {
      AppliedFilterRenderer: PropertyManagerAppliedFilterRenderer,
      FilterBody: PropertyManagerFilterBody,
      filterTriggerPlaceholder: 'User',
      appliedFilterTitle: 'User',
      ...getRenderedFiltersConfig(
        filtersIds.manager,
        filtersValues,
        updateFilterFn,
      ),
    },
    [filtersIds.pods]: {
      AppliedFilterRenderer: PodsAppliedFilterRenderer,
      FilterBody: PodsFilterBody,
      filterTriggerPlaceholder: 'Pod',
      appliedFilterTitle: 'Pod',
      ...getRenderedFiltersConfig(
        filtersIds.pods,
        filtersValues,
        updateFilterFn,
      ),
    },
    [filtersIds.status]: {
      AppliedFilterRenderer: StatusAppliedFilterRenderer,
      FilterBody: StatusFilterBody,
      filterTriggerPlaceholder: 'Status',
      appliedFilterTitle: 'Status',
      ...getRenderedFiltersConfig(
        filtersIds.status,
        filtersValues,
        updateFilterFn,
      ),
    },
    [filtersIds.sort]: {
      AppliedFilterRenderer: SortAppliedFilterRenderer,
      FilterBody: SortFilterBody,
      filterTriggerPlaceholder: 'Sort',
      appliedFilterTitle: 'Sort',
      ...getRenderedFiltersConfig(
        filtersIds.sort,
        filtersValues,
        updateFilterFn,
      ),
    },
  }
}
